import React from "react";

import moment from "moment";
import { Base64 } from "js-base64";
import { FormatIndentIncreaseSharp } from "@mui/icons-material";

function EmpWisTable({
  item,
  totalDistance,
  configurationName,
  communicationDetailsHeader,
  communicationDetailsDynamiceHeader,
}) {
  console.log(communicationDetailsDynamiceHeader, "fuheuyfyuerg");
  var base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

  console.log(
    item,
    totalDistance,
    configurationName,
    communicationDetailsHeader,
    communicationDetailsDynamiceHeader
  );

  const TotalDistance =
    item &&
    item.reduce(
      (accumulator, currentValue) =>
        Number(accumulator ? accumulator : 0) +
        Number(currentValue.totalDistance ? currentValue.totalDistance : 0),
      0
    );

  return (
    <>
      <table id="empwiseId">
        <tr rowSpan={3} colspan={2}>
          <th
            style={{
              // placeContent: "center",
              fontWeight: "bold",
            }}
            colspan={
              Number(
                communicationDetailsHeader && communicationDetailsHeader.length
              ) +
              Number(
                communicationDetailsDynamiceHeader &&
                  communicationDetailsDynamiceHeader.length
              )
            }
          >
            {TotalDistance && TotalDistance ? (
              <>
                <p>
                  {`Total Distance:- ${
                    TotalDistance && TotalDistance.toFixed(2)
                  }kms`}
                </p>
              </>
            ) : (
              0
            )}
          </th>
        </tr>

        <tr>
          {/* <th>Date</th>
          {configurationName !== undefined && configurationName === "IS_MEETING_DURATION" && (<>
            <td style={{ color: "#222" }} align="center">
              Meeting Start Time
            </td>
            <td style={{ color: "#222" }} align="center">
              Meeting End Time
            </td>
            <td style={{ color: "#222" }} align="center">
              Meeting Start Location
            </td>
            <td style={{ color: "#222" }} align="center">
              Meeting End Location
            </td>
            <td style={{ color: "#222" }} align="center">
              Meeting Duration
            </td>
          </>)}
          <th> OD Date/Time</th>
          <th>
            {" "}
            {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
              ? "Name Of Party"
              : " Vendor/Client/Other"}
          </th>
          <th>Contact Person</th>
          <th> Emp Name(Emp Code)</th>
          <th>  Client Status	</th>
          {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14 ?
            <th style={{ color: "#222" }} align="center">
              Party Type
            </th> : ""}
          <th>
            {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
              ? "Mobile No"
              : " Contact Person Number"}
          </th>
          <th> Meeting Type</th>
          <th>Reason</th>
          <th> Discussion Summary</th>
          <th>
            {" "}
            {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
              ? "Description"
              : " Remark"}
          </th>
          <th> Place of Visit</th>
          {JSON.parse(localStorage.getItem("showHeader")) == true ? (
            <>
              <th>Fare</th>
              <th> Meeting Distance Fare (₹)</th>
            </>
          ) : (
            ""
          )}
          <th>Meeting Expense Amount (₹)</th>
          <th> Total Distance(Kms)</th>
          <th>  Daily Distance Fare (₹)</th>
          <th> Total Expense (₹)</th>
          <th>Total Amount(₹)</th> */}
          {communicationDetailsDynamiceHeader &&
            communicationDetailsDynamiceHeader.map((dynamiceHeader) => {
              return (
                <>
                  {dynamiceHeader.IsShowWeb === true ? (
                    <th style={{ color: "#222" }}>
                      {dynamiceHeader && dynamiceHeader.label}
                    </th>
                  ) : (
                    ""
                  )}
                </>
              );
            })}

          {communicationDetailsHeader &&
            communicationDetailsHeader.map((header) => {
              return (
                <>
                  {header.isShowOnWeb === true && (
                    <th>
                      {header && header.displayName !== "Details"
                        ? header.displayName
                        : ""}
                    </th>
                  )}
                </>
              );
            })}
        </tr>
        {item &&
          item.length > 0 &&
          item.map((element, i, itemArray) => {
            return (
              element.clientCommunicationDtoList &&
              element.clientCommunicationDtoList.length > 0 &&
              element.clientCommunicationDtoList.map((elem, index, arr) => {
                let count;
                if (index == 0) {
                  count = 1;
                } else {
                  count = 0;
                }
                console.log(elem);

                return (
                  <tr
                    key={elem.id}
                    style={{
                      placeContent: "center",
                      backgroundColor: `${i % 2 == 0 ? "white" : "#F9F9F9"}`,
                    }}
                    hover
                  >
                    {elem &&
                      elem !== null &&
                      elem !== undefined &&
                      [elem].map((element, index, array) => {
                        // const n= elem.conclusion.includes("\n") &&  elem.conclusion.replace(/\n/, "");
                        //   const copy=elem.conclusion.slice()
                        //   const t =elem.conclusion.slice(0,elem.conclusion.length-3)
                        //   const isBase64Encdoed=base64regex.test(t+"==")

                        return (
                          <>
                            {communicationDetailsDynamiceHeader &&
                              communicationDetailsDynamiceHeader.map(
                                (header, ind) => {
                                  const headerName = header && header.uid;
                                  const jsonDataMap =
                                    element.jsonData != null
                                      ? Object.fromEntries(
                                          element.jsonData &&
                                            element.jsonData.map((e) => [
                                              e.uid,
                                              e.value,
                                            ])
                                        )
                                      : null;

                                  return (
                                    <>
                                      {header && header.IsShowWeb === true ? (
                                        <>
                                          {header.compName === "image" ||
                                          header.compName === "File" ? (
                                            <th align="center">
                                              {jsonDataMap &&
                                              jsonDataMap[headerName] != null &&
                                              jsonDataMap[headerName] !== ""
                                                ? jsonDataMap &&
                                                  jsonDataMap[headerName] !=
                                                    null
                                                  ? jsonDataMap[headerName]
                                                  : "NA"
                                                : "NA"}
                                            </th>
                                          ) : header.compName === "Checkbox" ? (
                                            <th align="center">
                                              {jsonDataMap &&
                                              jsonDataMap[headerName] != null &&
                                              jsonDataMap[headerName] !== "" &&
                                              jsonDataMap[headerName] !==
                                                undefined
                                                ? jsonDataMap[headerName] ==
                                                  true
                                                  ? "Yes"
                                                  : "NO"
                                                : "NA"}
                                            </th>
                                          ) : header.compName === "TextArea" ? (
                                            <th align="center">
                                              {/* {jsonDataMap &&
                                        jsonDataMap[
                                          headerName
                                        ] !==null &&
                                        jsonDataMap[
                                          headerName
                                        ] !== "" &&
                                       
                                        base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                          ? Base64.decode(
                                              jsonDataMap &&
                                                jsonDataMap[
                                                  headerName
                                                ] != null &&
                                                jsonDataMap[
                                                  headerName
                                                ] !== "" &&
                                                jsonDataMap[
                                                  headerName
                                                ] !==
                                                  undefined
                                                ? jsonDataMap[
                                                    headerName
                                                  ]
                                                : "NA"
                                            )
                                          : jsonDataMap &&
                                            jsonDataMap[
                                              headerName
                                            ] != null &&
                                            jsonDataMap[
                                              headerName
                                            ] !== "" &&
                                            jsonDataMap[
                                              headerName
                                            ] !== undefined
                                          ? jsonDataMap[
                                              headerName
                                            ]
                                          : "NA"} */}
                                              {jsonDataMap &&
                                              jsonDataMap[headerName] != null &&
                                              jsonDataMap[headerName] !== "" &&
                                              jsonDataMap[headerName] !==
                                                undefined
                                                ? jsonDataMap[headerName]
                                                : "NA"}
                                            </th>
                                          ) : header.compName === "Text" ? (
                                            <th align="center">
                                              {/* {jsonDataMap &&
                                        jsonDataMap[
                                          headerName
                                        ] !==null &&
                                        jsonDataMap[
                                          headerName
                                        ] !== "" &&
                                       
                                        base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                          ? Base64.decode(
                                              jsonDataMap &&
                                                jsonDataMap[
                                                  headerName
                                                ] != null &&
                                                jsonDataMap[
                                                  headerName
                                                ] !== "" &&
                                                jsonDataMap[
                                                  headerName
                                                ] !==
                                                  undefined
                                                ? jsonDataMap[
                                                    headerName
                                                  ]
                                                : "NA"
                                            )
                                          : jsonDataMap &&
                                            jsonDataMap[
                                              headerName
                                            ] != null &&
                                            jsonDataMap[
                                              headerName
                                            ] !== "" &&
                                            jsonDataMap[
                                              headerName
                                            ] !== undefined
                                          ? jsonDataMap[
                                              headerName
                                            ]
                                          : "NA"} */}
                                              {jsonDataMap &&
                                              jsonDataMap[headerName] != null &&
                                              jsonDataMap[headerName] !== "" &&
                                              jsonDataMap[headerName] !==
                                                undefined
                                                ? jsonDataMap[headerName]
                                                : "NA"}
                                            </th>
                                          ) : (
                                            <th align="center">
                                              {jsonDataMap &&
                                              jsonDataMap[headerName] != null &&
                                              jsonDataMap[headerName] !== "" &&
                                              jsonDataMap[headerName] !==
                                                undefined
                                                ? jsonDataMap[headerName]
                                                : "NA"}
                                            </th>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                                }
                              )}
                          </>
                        );
                      })}
                    {communicationDetailsHeader[0].isShowOnWeb === true && (
                      <td
                        style={{
                          minWidth: "140px",
                        }}
                      >
                        <span style={{ float: "right" }}>
                          {/* {elem.createDate} */}
                          {moment(elem.createdDateTime).format(
                            "DD/MM/YYYY hh:mm A"
                          )}
                        </span>
                      </td>
                    )}
                    {/* {configurationName !== undefined && configurationName === "IS_MEETING_DURATION" && (<> */}
                    {communicationDetailsHeader[1]?.isShowOnWeb === true && (
                      <td sx={{ minWidth: "180px" }} align="center">
                        {elem && elem.meetingOnDateTime
                          ? moment(elem.meetingOnDateTime).format("hh:mm A")
                          : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[2]?.isShowOnWeb === true && (
                      <td sx={{ minWidth: "180px" }} align="center">
                        {elem && elem.meetingOffDateTime
                          ? moment(elem.meetingOffDateTime).format("hh:mm A")
                          : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[3]?.isShowOnWeb === true && (
                      <td sx={{ minWidth: "180px" }} align="center">
                        {elem && elem.startAddress ? elem.startAddress : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[4]?.isShowOnWeb === true && (
                      <td sx={{ minWidth: "180px" }} align="center">
                        {elem && elem.address ? elem.address : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[5]?.isShowOnWeb === true && (
                      <td sx={{ minWidth: "180px" }} align="center">
                        {elem && elem.meetingDuration
                          ? elem.meetingDuration
                          : "NA"}
                      </td>
                    )}
                    {/* </>)} */}
                    {communicationDetailsHeader[6]?.isShowOnWeb === true && (
                      <td>
                        <p>
                          {`Start:  ${moment(element.createdDate).format(
                            "hh:mm: A"
                          )}${"\n"} End: ${moment(element.date).format(
                            "hh:mm: A"
                          )}`}
                          {/* Start:
                      {`$$moment(element.createdDate).format("hh:mm: A")}
                      End: {moment(element.date).format("hh:mm: A")`} */}
                        </p>
                        <p></p>
                      </td>
                    )}
                    {communicationDetailsHeader[7]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "160px",
                        }}
                      >
                        {elem.clientName}
                      </td>
                    )}
                    {communicationDetailsHeader[8]?.isShowOnWeb === true && (
                      <td align="center">{elem.contactPerson}</td>
                    )}
                    {communicationDetailsHeader[9]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "120px",
                        }}
                      >
                        {`${elem && elem.userName} ${
                          itemArray && itemArray[0].empCode
                            ? `(${itemArray[0].empCode})`
                            : "NA"
                        }`}
                      </td>
                    )}
                    {communicationDetailsHeader[10]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "120px",
                        }}
                      >
                        {elem &&
                        elem.clientCurrentStatus &&
                        elem.clientCurrentStatus !== null
                          ? elem.clientCurrentStatus.statusName
                          : "NA"}
                      </td>
                    )}
                    {/* {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14 ? */}
                    <>
                      {communicationDetailsHeader[11]?.isShowOnWeb === true && (
                        <td>
                          {elem && elem.clientType && elem.clientType !== null
                            ? elem.clientType
                            : "NA"}
                        </td>
                      )}
                    </>
                    {/* : ""} */}
                    {communicationDetailsHeader[12]?.isShowOnWeb === true && (
                      <td align="center">{elem.contactPersonNo}</td>
                    )}
                    {communicationDetailsHeader[13]?.isShowOnWeb === true && (
                      <td align="center">{elem.mode}</td>
                    )}
                    {communicationDetailsHeader[14]?.isShowOnWeb === true && (
                      <td align="center">{elem.reason}</td>
                    )}
                    {communicationDetailsHeader[15]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "120px",
                        }}
                      >
                        {/* {Base64.decode(elem.conclusion !==""?elem.conclusion:"NA")} */}
                        {elem &&
                        elem.conclusion &&
                        elem.conclusion.includes("\n") &&
                        base64regex.test(elem.conclusion.replace(/\n/, ""))
                          ? Base64.decode(elem.conclusion)
                          : elem.conclusion
                          ? elem.conclusion
                          : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[16]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "120px",
                        }}
                      >
                        {/* {Base64.decode(elem.remarks !==""?elem.remarks:"NA")} */}
                        {elem &&
                        elem.remarks &&
                        elem.remarks.includes("\n") &&
                        base64regex.test(elem.remarks.replace(/\n/, ""))
                          ? Base64.decode(elem.remarks)
                          : elem.remarks
                          ? elem.remarks
                          : "NA"}
                      </td>
                    )}
                    {communicationDetailsHeader[17]?.isShowOnWeb === true && (
                      <td
                        align="center"
                        style={{
                          minWidth: "120px",
                        }}
                      >
                        {elem.visitPlace || "NA"}
                      </td>
                    )}
                    {/* {JSON.parse(localStorage.getItem("showHeader")) == true ? ( */}
                    <>
                      {communicationDetailsHeader[18]?.isShowOnWeb === true && (
                        <td
                          align="center"
                          style={{
                            minWidth: "120px",
                          }}
                        >
                          {elem.meetingDistance
                            ? `${elem.meetingDistance} Kms`
                            : "0.00"}
                        </td>
                      )}
                      {communicationDetailsHeader[19]?.isShowOnWeb === true && (
                        <td
                          align="center"
                          style={{
                            minWidth: "120px",
                          }}
                        >
                          {elem.distanceFare
                            ? `${`${elem.distanceFare.toFixed(2)}(₹).`} `
                            : "0.00"}
                        </td>
                      )}
                    </>
                    {communicationDetailsHeader[20]?.isShowOnWeb === true && (
                      <td>
                        {" "}
                        {elem.clientTotalExpenseAmount
                          ? `${`${elem.clientTotalExpenseAmount.toFixed(
                              2
                            )}`}`
                          : "0.00"}
                      </td>
                    )}
                    {count == 1 && (
                      <>
                        {communicationDetailsHeader[21]?.isShowOnWeb ===
                          true && (
                          <td
                            sx={{
                              borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            }}
                            align="center"
                            rowSpan={arr.length}
                          >
                            {/* {element.totalDistance?element.totalDistance.toFixed(2):"NA"} */}
                            {element.totalDistance
                              ? `${element.totalDistance.toFixed(2)}`
                              : "0.00"}

                            {/* <img src={eyeIcon}></img> */}
                            {/* View */}
                          </td>
                        )}
                      </>
                    )}{" "}
                    {count == 1 && (
                      <>
                        {communicationDetailsHeader[22]?.isShowOnWeb ===
                          true && (
                          <td
                            sx={{
                              borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            }}
                            align="center"
                            rowSpan={arr.length}
                          >
                            {/* {element.totalDistance?element.totalDistance.toFixed(2):"NA"} */}
                            {element.totalAmountForOd
                              ? `${Math.floor(element.totalAmountForOd)}`
                              : "0.00"}

                            {/* <img src={eyeIcon}></img> */}
                            {/* View */}
                          </td>
                        )}
                      </>
                    )}{" "}
                    {count == 1 && (
                      <>
                        {communicationDetailsHeader[23]?.isShowOnWeb ===
                          true && (
                          <td
                            sx={{
                              borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            }}
                            align="center"
                            rowSpan={arr.length}
                          >
                            {/* {element.totalDistance?element.totalDistance.toFixed(2):"NA"} */}
                            {element.odExpenseAmount
                              ? `${element.odExpenseAmount}₹`
                              : "0.00"}

                            {/* <img src={eyeIcon}></img> */}
                            {/* View */}
                          </td>
                        )}
                      </>
                    )}{" "}
                    {count == 1 && (
                      <>
                        {communicationDetailsHeader[24]?.isShowOnWeb ===
                          true && (
                          <td
                            sx={{
                              borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            }}
                            align="center"
                            rowSpan={arr.length}
                          >
                            {/* <img src={eyeIcon}></img> */}
                            {/* {element.totalExpenseAndFareAmount
                          ? `${Math.floor(element.totalExpenseAndFareAmount)}`
                          : "NA"} */}
                            {`Approve: ${
                              element.totalApprovedExpenseAndFareAmount
                                ? `${element.totalApprovedExpenseAndFareAmount.toFixed(
                                    2
                                  )}`
                                : "0.00"
                            }, Rejected: ${
                              element.totalRejectedExpenseAndFareAmount
                                ? `${element.totalRejectedExpenseAndFareAmount.toFixed(
                                    2
                                  )}`
                                : "0.00"
                            }, Pending: ${
                              element.totalPendingExpenseAndFareAmount
                                ? `${element.totalPendingExpenseAndFareAmount.toFixed(
                                    2
                                  )}`
                                : "0.00"
                            }, Total:${
                              element.totalExpenseAndFareAmount
                                ? `${element.totalExpenseAndFareAmount}`
                                : "0.00"
                            }`}
                          </td>
                        )}
                      </>
                    )}
                  </tr>
                );
              })
            );
          })}
      </table>
    </>
  );
}

export default EmpWisTable;
